import mapMarker from "../img/icons/map_marker_hover.svg";

const locations = {
    en: [
            {
                id: "1",
                position: { lat: 41.7097154, lng: 44.7534108 },
                title: "4 Archil Mishveladze str, Tbilisi",
                link: "https://maps.app.goo.gl/evusPe8QR7qdTTuA7",
                icon: mapMarker,
                table: [
                    {
                        open: "Monday - Sunday",
                        time: "10:00—22:00",
                    },
                ]
            },
            {
                id: "2",
                position: { lat: 41.724285836193474, lng: 44.73766654729843 },
                title: "70 Vazha Pshavela Ave, City Mall, Tbilisi",
                link: "https://www.google.com/maps/search/70+Vazha+Pshavela+Ave+City+Mall+Tbilisi+Georgia",
                icon: mapMarker,
                table: [
                    {
                        open: "Monday - Sunday",
                        time: "10:00—22:00",
                    },
                ]
            },
            {
                id: "3",
                position: { lat: 41.63544699824777, lng: 41.607850492000566 },
                title: "29 Sherif Khimshiashvili str, Grand Mall, Batumi",
                link: "https://www.google.com/maps/search/29+Sherif+Khimshiashvili+Grand+Mall+Batumi+Georgia",
                icon: mapMarker,
                table: [
                    {
                        open: "Monday - Sunday",
                        time: "10:00—22:00",
                    },
                ]
            },
        ],
    ka:  [
        {
            id: "1",
            position: { lat: 41.7097154, lng: 44.7534108 },
            title: "არჩილ მიშველაძის ქუჩა #4, ვაკის პარკი, თბილისი",
            link: "https://maps.app.goo.gl/evusPe8QR7qdTTuA7",
            icon: mapMarker,
            table: [
                {
                    open: "ორშაბათი - კვირა",
                    time: "10:00—22:00",
                },
            ]
        },
        {
            id: "2",
            position: { lat: 41.724285836193474, lng: 44.73766654729843 },
            title: "ვაჟა-ფშაველას გამზირი #70, სითი მოლი, თბილისი",
            link: "https://www.google.com/maps/search/70+Vazha+Pshavela+Ave+City+Mall+Tbilisi+Georgia",
            icon: mapMarker,
            table: [
                {
                    open: "ორშაბათი - კვირა",
                    time: "10:00—22:00",
                },
            ]
        },
        {
            id: "3",
            position: { lat: 41.63544699824777, lng: 41.607850492000566 },
            title: "შერიფ ხიმშიაშვილის ქუჩა #29, გრანდ მოლი, ბათუმი",
            link: "https://www.google.com/maps/search/29+Sherif+Khimshiashvili+Grand+Mall+Batumi+Georgia",
            icon: mapMarker,
            table: [
                {
                    open: "ორშაბათი - კვირა",
                    time: "10:00—22:00",
                },
            ]
        },
    ]
}

export {
    locations
};
